import React from 'react';
import { Service } from '../types';
import { Bullet, Home, ShoppingCart, Support } from './Icons';

const iconMapping = [
  { iconName: 'home', icon: Home },
  { iconName: 'webshop', icon: ShoppingCart },
  { iconName: 'support', icon: Support },
];

export type MenuItem = {
  label: string;
  icon: React.ReactNode;
  to: string;
  external?: boolean;
  pinned?: boolean;
};

const mapToIcon = (item: Service) => iconMapping.find((i) => i.iconName === item?.iconUrl)?.icon || Bullet;

export const mapToMenuItem = (service: Service): MenuItem => ({
  label: (service?.switcherDisplayName ? service?.switcherDisplayName : service?.name) || '',
  icon: mapToIcon(service)(),
  to: service?.serviceUrl || '',
  external: true,
});

export const mapToMenuItems = function (services: Service[]): MenuItem[] {
  let normalServices = services?.filter((a) => (a.switcherOrdering || 0) >= 0);
  let pinnedServices = services?.filter((a) => a.switcherOrdering < 0);

  return normalServices.map(mapToMenuItem).concat(pinnedServices.map(mapToMenuItem).map((a) => ({ ...a, pinned: true })));
};

export const getVSimService = function (serviceUrl: string): Service {
  return {
    name: 'vSim for Nursing',
    serviceUrl: serviceUrl,
  } as Service;
};


export const rewriteForMarket = function (url: string, market?: string): string {
  if (!market)  return url;

  return url.replace('https://laerdal.com', `https://laerdal.com/${market}`)
    .replace('https://uat.laerdal.com', `https://uat.laerdal.com/${market}`)
    .replace('https://test.laerdal.com', `https://test.laerdal.com/${market}`);
};

